import { iButtonDisplayOptions } from 'fulogics-ui-web/dist/layout/dx/Button/Button';
import propsStore from 'fulogics-ui-web/dist/layout/inspector/propsStore';

export const orderErrorInfoEditButtonId = 'OrderErrorInfoEditButton';
const orderErrorInfoEditButtonOptions: iButtonDisplayOptions = {
    id: orderErrorInfoEditButtonId,
    text: 't~OrderErrorInfo:editButton',
    stylingMode: 'text',
    type: 'success',
};
propsStore.insert(orderErrorInfoEditButtonOptions);
